document.addEventListener('DOMContentLoaded', function () {
    const isRisultatiPage = document.body.classList.contains('Risultati');

    window.addEventListener('scroll', function () {
        if (window.scrollY > 256) {
            document.body.classList.add('scrolled');
        } else if (window.scrollY <= 0 && !isRisultatiPage) {
            document.body.classList.remove('scrolled');
        }
    });
});